export function path() {
    //const prod = '';
    return "https://svbeta.ventus.network"
    //return "http://127.0.0.1:5020"
}